'use strict';

var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var debounce = require('lodash.debounce');

var Message = require('../types/message');

var logger = require('../utils').logger;

module.exports =
/*#__PURE__*/
function () {
  function MsgQueue(selfPeerId, otherPeerId, network) {
    _classCallCheck(this, MsgQueue);

    this.peerId = otherPeerId;
    this.network = network;
    this.refcnt = 1;
    this._entries = [];
    this._log = logger(selfPeerId, 'msgqueue', otherPeerId.toB58String().slice(0, 8));
    this.sendEntries = debounce(this._sendEntries.bind(this), 200);
  }

  _createClass(MsgQueue, [{
    key: "addMessage",
    value: function addMessage(msg) {
      if (msg.empty) {
        return;
      }

      this.send(msg);
    }
  }, {
    key: "addEntries",
    value: function addEntries(entries) {
      this._entries = this._entries.concat(entries);
      this.sendEntries();
    }
  }, {
    key: "_sendEntries",
    value: function _sendEntries() {
      if (!this._entries.length) {
        return;
      }

      var msg = new Message(false);

      this._entries.forEach(function (entry) {
        if (entry.cancel) {
          msg.cancel(entry.cid);
        } else {
          msg.addEntry(entry.cid, entry.priority);
        }
      });

      this._entries = [];
      this.addMessage(msg);
    }
  }, {
    key: "send",
    value: function send(msg) {
      var _this = this;

      this.network.connectTo(this.peerId, function (err) {
        if (err) {
          _this._log.error('cant connect to peer %s: %s', _this.peerId.toB58String(), err.message);

          return;
        }

        _this._log('sending message');

        _this.network.sendMessage(_this.peerId, msg, function (err) {
          if (err) {
            _this._log.error('send error: %s', err.message);
          }
        });
      });
    }
  }]);

  return MsgQueue;
}();